var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fa-stack"},[_c('span',{staticClass:"counter-text c-white"},[_vm._v(_vm._s(_vm.num))]),_c('i',{staticClass:"fa-stack-2x fas fa-circle c-blue"})])}
var staticRenderFns = []

export { render, staticRenderFns }